import { render, staticRenderFns } from "./Page6Item.vue?vue&type=template&id=8f023d60&scoped=true"
import script from "./Page6Item.vue?vue&type=script&lang=js"
export * from "./Page6Item.vue?vue&type=script&lang=js"
import style0 from "./Page6Item.vue?vue&type=style&index=0&id=8f023d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f023d60",
  null
  
)

export default component.exports